<!--suppress TypeScriptUnresolvedVariable, TypeScriptUnresolvedFunction -->
<div fxLayout="column" class="merge-config-container">
    <div fxLayout="row" fxLayoutAlign="center" class="mb-16">
        <span>{{'Type'|i18n}}: <strong>{{cfg.type|connectorType}}</strong></span>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
        <form novalidate [formGroup]="form" fxLayout="column" fxLayoutGap="0.5rem" fxFlex="50" class="merge-form">
        </form>
    </div>
    <app-divider class="mt-8 mb-8" gap="0.5rem">{{'Virtual devices'|i18n}}</app-divider>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-8">
        <button mat-stroked-button color="primary" class="add-device-button"
                (click)="onClickAddDevice()">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add virtual device'|i18n}}
        </button>
    </div>
    <div fxLayout="column" fxLayoutGap="8px" class="mt-16">
        <ng-container *appVar="pagedDevs|async as devs">
            <ng-container *ngIf="devs">
                <div *ngFor="let dev of devs.data; trackBy: trackByDevId"
                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
                    <div fxLayoutAlign="end" fxFlex="grow">
                        <em>{{dev.devId}}</em>
                    </div>
                    <form novalidate [formGroup]="dev.form" fxLayoutAlign="center" fxFlex="shrink" fxLayoutGap="0.5rem"
                          class="device-form">
                        <mat-form-field fxFlex="shrink">
                            <mat-select placeholder="{{'Mode'|i18n}}" formControlName="mode">
                                <mat-option *ngFor="let mode of MERGE_DEVICE_MODES" [value]="mode">
                                    {{mode|mergeDeviceMode|i18n}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="!dev.form.controls.mode.valid">
                                {{'Invalid mode'|i18n}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field fxFlex="grow" class="measures-field">
                            <mat-select multiple formControlName="measures" placeholder="{{'Measures'|i18n}}">
                                <mat-option *ngFor="let measure of allMeasures; trackBy: trackByMeasure"
                                            [value]="measure">
                                    {{measure}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="!dev.form.controls.measures.valid">
                                {{'Two measures at least needed'|i18n}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="uom-field">
                            <input matInput placeholder="{{'UoM'|i18n}}" formControlName="uom"
                                   [title]="'Unit of measure'|i18n">
                            <mat-error *ngIf="!dev.form.controls.uom.valid">
                                {{'Invalid UoM'|i18n}}
                            </mat-error>
                        </mat-form-field>
                    </form>
                    <div fxLayoutAlign="start" fxFlex="grow" fxLayoutGap="0.5rem">
                        <button class="operation-button" [ngClass]="{'warn': !isValidDevice(dev)}"
                                [title]="'Expression/algorithm'|i18n"
                                [disabled]="!dev.form.controls.measures.valid"
                                (click)="onClickDeviceExpression(dev)">
                            <app-icon name="fab-python"></app-icon>
                        </button>
                        <button class="operation-button" [title]="'Rename virtual device'|i18n"
                                (click)="onClickRenameDevice(dev.devId)">
                            <app-icon name="fal-edit"></app-icon>
                        </button>
                        <button class="operation-button warn" [title]="'Remove virtual device'|i18n"
                                (click)="onClickDeleteDevice(dev.devId)">
                            <app-icon name="fal-trash-alt"></app-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
            <mat-paginator #devsPaginator app-paginator class="merge-paginator"
                           [ngClass]="{'collapsed': !devs || devs.total === 0}"
                           [length]="devs?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
        </ng-container>
    </div>
</div>

<ng-template #addDevice let-data>
    <h1 mat-dialog-title>{{'Add device'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameDevice let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field>
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteDevice let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['devId']}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deviceExpression let-data>
    <h1 mat-dialog-title>{{'Expression/algorithm for {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="expression-editor">
        <form novalidate [formGroup]="data['form']" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="center" class="mt-10 mb-24">
                <mat-radio-group fxLayout="column" color="primary" formControlName="useAlgo"
                                 (change)="onChangeExpressionVSAlgorithm(data['form'], $event)">
                    <mat-radio-button [value]="false" class="mb-8">{{'Expression'|i18n}}</mat-radio-button>
                    <mat-radio-button [value]="true">{{'Algorithm'|i18n}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <app-expression-editor formControlName="expression"
                                   [algorithmMode]="data['form'].controls.useAlgo.value"
                                   [features]="data['features']">
            </app-expression-editor>
            <span *ngIf="!data['form'].controls.expression.valid" class="expression-error">
                {{(!data['form'].controls.useAlgo.value ? 'Invalid expression' : 'Invalid algorithm')|i18n}}
            </span>
        </form>
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1rem" class="mt-8">
            <span class="measures">
                {{'Measures'|i18n}}: {{data['measures'].join(', ')}}
            </span>
            <app-icon name="fal-question-circle" class="expression-help"
                      [matTooltip]="(data['form'].controls.useAlgo.value ? ALGORITHM_HELP : EXPRESSION_HELP)|i18n"
                      matTooltipClass="fs-1">
            </app-icon>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>
